import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { IconButton } from "../Buttons";

/**
 * EyeIconButton - Preview eye icon button
 * 
 * @param {Object} props
 * @param {function} props.onPreviewClick - Custom preview click handler
 * @param {Object} props.previewData - Data to pass to preview route
 * @param {boolean} props.disabled - Disable eye icon
 * @param {string} props.title - Tooltip text
 */
const EyeIconButton = ({ onPreviewClick, previewData, disabled = false, title }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return;
    if (onPreviewClick) {
      onPreviewClick();
    } else {
      navigate("/preview", {
        state: previewData,
      });
    }
  };

  return (
    <IconButton
      icon={<FontAwesomeIcon icon={faEye} />}
      onClick={handleClick}
      disabled={disabled}
      title={title}
      className="icon-button"
      style={{
        marginTop: "10px",
        color: "#0D6EFD",
        border: "1px solid #0D6EFD",
        borderRadius: "3px",
        padding: "4px",
      }}
      ariaLabel="Preview"
    />
  );
};

export default EyeIconButton;

